import { Copyright } from "lucide-react";

interface FooterProps {
  showVersion?: boolean;
  version?: string;
}

export function FooterComponent({
  showVersion = true,
  // Default to the build-time app version from package.json (see vite.config.ts `define`),
  // so the footer always reflects the real release version instead of a hardcoded string.
  version = __APP_VERSION__,
}: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-t py-3 mt-auto z-40 transition-all duration-300 ease-in-out"
      aria-label="Footer navigation"
    >
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
        {/* Left Section: Copyright & Company */}
        <div className="flex items-center gap-1.5 transition-opacity hover:opacity-80">
          <Copyright className="h-3 w-3" />
          <span className="font-semibold text-foreground/80 tracking-tight">
            Trilogy Networks, Inc. {currentYear}
          </span>
        </div>

        {/* Right Section: Version */}
        {showVersion && (
          <span className="font-mono text-[10px] opacity-70">v{version}</span>
        )}
      </div>
    </footer>
  );
}

